
App.factory('domainService',function($http, $q, $rootScope){
	var service = {},
		deffered,
		canceller;

	// check for domain
	service.checkTld = function(domain) {
		if (deffered) {
			deffered.reject();
		}

		deffered = $q.defer();

		if ($rootScope.anytld.length === 1 && domain.indexOf('.') == -1) {
			// append tld if only one result
			domain = domain + '.' + $rootScope.anytld[0];
    	}

		ajaxCall('/domains/available', 'POST', JSON.stringify({ "domain": domain, "any_tld": $rootScope.anytld }), function(resp){
			deffered.resolve(resp);
		});

		return deffered.promise;
	}

	// stop all http requests
	service.stop = function() {
		if (canceller) {
			void 0;
			canceller.resolve();
			deffered.reject();
		}

		$rootScope.ajax = false;
		$rootScope.suggestions = [];
		$rootScope.available = false;
		$rootScope.domainError = false;
	}

	// register domain
	service.registerDomain = function(data, category, purpose) {
		if (deffered) {
			deffered.reject();
		}

		deffered = $q.defer();

		// convert data from angular to object
		data = angular.copy(data);

		// prepare any additional data
		data.additional_data = {};
		if (typeof category != 'undefined' && category != null) {
			data.additional_data.category = category;
		}

		if (typeof purpose != 'undefined' && purpose != null) {
			data.additional_data.purpose = purpose;
		}

		void 0;

		// perform actual registration
		ajaxCall('/register/existing', 'POST', JSON.stringify(data), function(resp) {
			deffered.resolve(resp);
		});

		return deffered.promise;
	}

	// simple registration for promo code users
	service.simpleRegisterDomain = function(data) {
		if (deffered) {
			deffered.resolve();
		}

		deferred = $q.defer();

		// perform actual registration
		ajaxCall('/register/simple', 'POST', JSON.stringify(data), function(resp) {
			deffered.resolve(resp);	
		});
		
		return deffered.promise;
	};

	// check if domain is transferrable
	service.isDomainTransferValid = function(data) {
		if (deffered) {
			deffered.resolve();
		}

        deffered = $q.defer();

        // perform actual registration
		ajaxCall('/domains/transfer/validate', 'POST', JSON.stringify(data), function(resp) {
			deffered.resolve(resp);
		});

		return deffered.promise;
	};

	// check if domain is transferrable and transfer token is valid
	service.isDomainTransferTokenValid = function(data) {
		if (deffered) {
			deffered.resolve();
		}

        deffered = $q.defer();

        // perform actual registration
		ajaxCall('/domains/transfer/validate/token', 'POST', JSON.stringify(data), function(resp) {
			deffered.resolve(resp);
		});

		return deffered.promise;
	};

	// simple registration for external/dlp users
	service.externalSignup = function(data) {
		if (deffered) {
			deffered.resolve();
		}

        deffered = $q.defer();

        // perform actual registration
		ajaxCall('/domains_external', 'POST', JSON.stringify(data), function(resp) {
			deffered.resolve(resp);
		});

		return deffered.promise;
	};

	service.sanitizeDomainSearch = function(viewValue, currentBundle, anytld) {
		var validDomainRegex = '^[a-zA-Z0-9\\-]+\\..+$',
			validDomainRegexNoTld = '^[a-zA-Z0-9\\-\\s]+$',
			validDomainCo = '^[a-zA-Z0-9\\-]+\\.co$',
			validDomainCoXyz = '^[a-zA-Z0-9\\-]+\\.(co|xyz)?$',
			validationRegex = '';

		if (viewValue.indexOf(".") != -1) {
			// first check what type of bundle that way we can switch regex
			if (currentBundle == "myo") {
				//whoa whoa buddy, now we need to validate with a period
				validationRegex = validDomainRegex;
				//remove invalid characters
				viewValue = viewValue.replace(/[^a-zA-Z0-9-\\.]/ig,'');
			} else {
                var exts = anytld.join('|');
                var regreplace = new RegExp('[^a-zA-Z0-9-\\.('+exts+')?$]', 'ig');

                validationRegex = '^[a-zA-Z0-9\\-]+\\.('+exts+')?$';

                // remove invalid characters
				viewValue = viewValue.replace(regreplace,'');
			}
		} else {
			// ok fine just validate domain without a period
			validationRegex = validDomainRegexNoTld;

			// remove invalid characters, except spaces
			viewValue = viewValue.replace(/[^a-zA-Z0-9- ]/ig,'');
		}

		// create regex
		var regex = new RegExp(validationRegex, 'ig');

		// users do silly things with www
        return [ viewValue.replace('www.',''), regex ];
	};

	function ajaxCall(url, method, data, callback) {
		$http.defaults.useXDomain = true;
		$http.defaults.headers.common['X-Bottle-Cap'] = POP.bottleCap;
		$rootScope.ajax = true;

		canceller = $q.defer();

		$http({
			url: POP.apiBaseUrl + url,
			method: method,
			data: data,
			withCredentials: true,
			timeout: canceller.promise,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			}
		}).success(function(resp) {
			$rootScope.ajax = false;
			callback(resp);
			
		}).error(function(resp) {
			$rootScope.ajax = false;
			callback(resp);
		});

	}

	return service;
});
